import { Navigate } from "react-router-dom";
import { useAuth } from "../context/Auth";
import { tokenVigente } from "./tokenVigente";

//Páginas públicas (portada, login, registro...): con la sesión iniciada se va directamente a /home
export const LoggedRoute = ({ children }) => {

    const { currentUser, sessionToken } = useAuth();

    if (currentUser && tokenVigente(sessionToken)) {
        return <Navigate to="/home" />;
    }
    return children;

}
